<template>
    <div class="imgAndServe">
        <!--未来，从META开始-->
        <div class="imgWrapBox imgWrapBox1">
            <div class="imgWrapConBox">
                <div class="imgWrapBoxTitle">未来，从羽拾开始</div>
                <div class="imgWrapBoxVal">
                    羽拾科技有限公司旗下拥有魅塔（META）大数据平台，平台基于神经网络计算、挖掘、清洗加工技术进行数学建模，致力于为企业提供智能通用产品、辅助决策与客群洞察、战略合作等服务，同时为传统行业解决痛点并赋能多产业升级
                </div>
            </div>
            <img src="../../../assets/img/home/homeImg1.png" class="imgWrap" :width="img1H" alt=""/>
        </div>
        <!--一样的服务，不一样的能力-->
        <div class="serveWrap">
            <div class="headline">一样的服务，不一样的能力</div>
            <div class="serveListBox">
                <div class="serveList">
                    <img src="../../../assets/img/home/数据.png" alt=""/>
                    <div class="serveListTitle">数据整合</div>
                    <p>拥有海量经过技术挖掘、清洗加工结合商业参数验证出来的优质参数；参数具有广维度特性，其中包括社交、风控、金融、保险、电商、KOL等维度</p>
                </div>
                <div class="serveList">
                    <img src="../../../assets/img/home/神经网络.png" alt=""/>
                    <div class="serveListTitle">参数应用</div>
                    <p>通过机器学习技术进行聚类分析，学习用户行为，建立数学模型，输出结果后根据实际场景提供相应的服务，包括市场动态分析、产品精准营销、用户画像评级、⻛险预警等服务</p>
                </div>
                <div class="serveList">
                    <img src="../../../assets/img/home/团队.png" alt=""/>
                    <div class="serveListTitle">极客团队</div>
                    <p>全海归属性极客级技术团队与优质的业务数据分析团队，曾在金融及部分金融量化领域全国排名前三，拥有从商业分析到数据生态搭建的完善体系</p>
                </div>
                <div class="serveList">
                    <img src="../../../assets/img/home/安全服务.png" alt=""/>
                    <div class="serveListTitle">安全服务</div>
                    <p>保障大数据交换时的信息安全、保护终端数据和个人数据隐私、保证合法合规的前提下，在多参与方或多计算节点之间开展高效率的机器学习</p>
                </div>
            </div>
        </div>
        <!--行业领先的数字营销服务-->
        <div class="yxfwWrap">
            <div class="headline yxfwWrapH">行业领先的数字营销服务</div>
            <div class="bigImg">
                <img src="../../../assets/img/home/logo.png" class="logo" alt=""/>
                <p>
                    海量独家合作高质媒体，全网多场景流量覆盖，线上线下多维数据整合，根据用户需求提供定制化的营销解决方案，采取精细化运营方式，实时反馈营销效果数据，致力打造行业领先的数字营销服务
                </p>
                <!--合作媒体-->
                <div class="hzmtBox">
                    交互类合作媒体&平台类合作媒体：
                    <div class="imgWrap">
                        <img src="../../../assets/img/home/腾讯@2x.png" alt=""/>
                        <img src="../../../assets/img/home/百度logo@2x.png" alt=""/>
                        <img src="../../../assets/img/home/抖音logo@2x.png" alt=""/>
                        <img src="../../../assets/img/home/推啊logo@2x.png" alt=""/>
                        <img src="../../../assets/img/home/华为@2x.png" alt=""/>
                        <img src="../../../assets/img/home/oppo@2x.png" alt=""/>
                        <img src="../../../assets/img/home/vivo@2x.png" alt=""/>
                    </div>
                </div>
            </div>
            <div class="fwList">
                <div class="list">
                    <div class="fwTitle">专业的媒体营销推广团队</div>
                    <p class="fwCon">
                        拥有专业的市场团队深度了解客户真实需求、优化运营团队根据产品特性优化策略、设计团队打造符合产品特性的图片、视频方案、媒介团队第一时间抢占流量红利
                    </p>
                </div>
                <div class="list">
                    <div class="fwTitle">行业领先的客户资源储备</div>
                    <p class="fwCon">
                        通过多年的营销获客领域深耕，羽拾已和腾讯、银行、大分发商建立了深度的合作关系，其中浦发银行、广发银行、中信银行的发卡名列全行top5 </p>
                </div>
                <div class="list">
                    <div class="fwTitle">全网顶级流量精准加持</div>
                    <p class="fwCon">
                        覆盖全网合作，其中包括腾讯广告、头条、抖音、百度推广、推啊等顶级流量互动类媒体，还有华为、vivo\oppo等类别的厂商类媒体
                    </p>
                </div>
            </div>
        </div>
        <!--弹框-->
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false" alt=""/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "imgAndServe",
        data() {
            return {
                img1H: 1200,
                img2H: 1200,
                scrollAction: {
                    y: 'undefined'
                },
                showAlertFlag: false,
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByClassName("imgWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("serveWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("imgWrapConBox")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("yxfwWrapH")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("bigImg")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("fwList")[0], "fadeInUp");

                /*图片放大缩小效果*/
                let img1H = document.getElementsByClassName("imgWrap")[0];
                /*DOM元素局顶部距离*/
                let domTop1 = img1H.offsetTop;
                /*滑动距离*/
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                // 判断滑动方向
                if (typeof this.scrollAction.y == 'undefined') {
                    this.scrollAction.y = window.scrollY;
                }
                let diffY = this.scrollAction.y - window.scrollY;
                if (diffY < 0) {
                    // 下
                    if (scrollTop >= 600) {
                        this.img1H += 10;
                        if (this.img1H >= 1800) {
                            this.img1H = 1800;
                        }
                    }
                } else if (diffY > 0) {
                    // 上
                    if (domTop1 >= scrollTop) {
                        this.img1H -= 10;
                        if (this.img1H <= 1200) {
                            this.img1H = 1200;
                        }
                    }
                }
                this.scrollAction.y = window.scrollY;
            },
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    .imgAndServe {
        .imgWrapBox {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 120px;
            text-align: center;

            .imgWrapConBox {
                position: absolute;
                width: 1200px;
                height: 386px;
                z-index: 100;
            }

            .imgWrap {
                position: relative;
            }
        }

        .imgWrapBox1 {
            .imgWrapConBox {
                padding: 100px 107px 0;

                .imgWrapBoxTitle {
                    margin-bottom: 20px;
                    font-size: 60px;
                    color: #FFFFFF;
                    text-align: justify;
                }

                .imgWrapBoxVal {
                    max-width: 595px;
                    opacity: 0.8;
                    font-size: 12px;
                    color: #fff;
                    text-align: justify;
                    line-height: 24px;
                }
            }
        }

        .yxfwWrap {
            width: 1200px;
            margin: 0 auto 120px;

            .headline {
                margin-bottom: 60px;
            }

            .bigImg {
                width: 100%;
                height: 345px;
                padding: 96px 0 77px 47px;
                margin-bottom: 30px;
                background: url("../../../assets/img/home/houselai@2x.png") no-repeat center;
                background-size: cover;

                .logo {
                    margin-bottom: 17px;
                }

                p {
                    width: 779px;
                    margin-bottom: 50px;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: justify;
                    line-height: 24px;
                }

                .hzmtBox {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: rgba(255, 255, 255, .4);
                    text-align: justify;

                    .imgWrap {
                        margin-left: 7px;

                        img {
                            margin-right: 47px;

                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    }
                }
            }

            .fwList {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .list {
                    width: 382px;
                    height: 180px;
                    padding: 30px 41px 33px;

                    &:nth-child(1) {
                        background: url("../../../assets/img/home/bg-专业团队@2x.png") no-repeat center;
                        background-size: cover;
                    }

                    &:nth-child(2) {
                        background: url("../../../assets/img/home/bg-客户资源@2x.png") no-repeat center;
                        background-size: cover;
                    }

                    &:nth-child(3) {
                        background: url("../../../assets/img/home/bg-顶级流量@2x.png") no-repeat center;
                        background-size: cover;
                    }

                    .fwTitle {
                        margin-bottom: 12px;
                        font-size: 24px;
                        color: #FFFFFF;
                        text-align: justify;
                    }

                    .fwCon {
                        opacity: 0.8;
                        font-size: 12px;
                        color: #FFFFFF;
                        text-align: justify;
                        line-height: 24px;
                    }
                }
            }
        }

        .serveWrap {
            width: 1200px;
            margin: 0 auto;

            .serveListBox {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-bottom: 120px;

                .serveList {
                    width: 500px;
                    margin-bottom: 14px;

                    &:nth-child(3), &:nth-child(4) {
                        margin-bottom: 0;
                    }

                    img {
                        width: 50px;
                        height: 50px;
                        margin-bottom: 8px;
                    }

                    .serveListTitle {
                        margin-bottom: 10px;
                        font-size: 16px;
                        line-height: 22px;
                        color: #152346;
                    }

                    p {
                        opacity: 0.6;
                        font-size: 12px;
                        color: #152346;
                        text-align: justify;
                        line-height: 24px;
                    }
                }
            }
        }
    }


</style>